import { RouteModule } from '#/horizon/components/RouteModule';
import { useI18n } from '#/i18n/hooks/useI18n';
import type { LayoutHandleProps } from '#/layouts/Layout/LayoutHandleProps';
import { orgDashboardGradFairsApiIsomorphicFetchInvite } from '#/modules/orgDashboard/gradFairs/api/orgDashboardGradFairsApiFetchInvite';
import { orgDashboardViewGradFairInviteRoute } from '#/modules/orgDashboard/routing/orgDashboard.routes';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';

import { OrgDashboardViewGradFairInvitePageLoadable } from './OrgDashboardViewGradFairInvitePageLoadable';

export const handle = {
  fallbackUrlByLocaleToCurrent: true,
  darkBackground: true,
  showDesktopSearch: true,
} satisfies LayoutHandleProps;

export async function loader({
  request,
  context,
  params: { orgId, inviteId },
}: HorizonAppRouteLoaderArgs<typeof orgDashboardViewGradFairInviteRoute>) {
  const [{ invite, location, fairCredits }] = await Promise.all([
    orgDashboardGradFairsApiIsomorphicFetchInvite({ request, context })(
      orgId,
      inviteId,
    ),
    OrgDashboardViewGradFairInvitePageLoadable.load(),
  ]);

  return { invite, location, fairCredits };
}

export default function OrgDashboardViewGradFairInviteHorizonRoute({
  loaderData: { invite, location, fairCredits },
}: HorizonAppRouteComponentProps<typeof loader>) {
  const { i18n } = useI18n();

  return (
    <RouteModule title={i18n('Grad Fair Invitation')}>
      <OrgDashboardViewGradFairInvitePageLoadable
        invite={invite}
        location={location}
        fairCredits={fairCredits}
      />
    </RouteModule>
  );
}
